import { render } from "./LayoutDefault.vue?vue&type=template&id=dd284aa0"
import script from "./LayoutDefault.vue?vue&type=script&lang=ts"
export * from "./LayoutDefault.vue?vue&type=script&lang=ts"
script.render = render

export default script